import React from 'react';
import { useNavigate } from 'react-router-dom';



import type { SearchResultsDropdownProps } from '../../types/Layouts.component-props.types';
const SearchResultsDropdown = ({
    searchResults,
    loading,
    getTypeLabel,
    handleResultClick,
}: SearchResultsDropdownProps) => {
    const navigate = useNavigate();
    return (
        <div className="absolute bg-white-blue-50 top-full left-0 right-0 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-96 overflow-y-auto">
            {loading ? (
                <div className="p-4 text-center text-gray-500">جاري البحث...</div>
            ) : (
                <div className="py-2">
                    {Object.entries(searchResults).map(([type, items]: [string, any]) => {
                        if (!Array.isArray(items) || items.length === 0) return null;

                        return (
                            <div key={type} className="border-b border-gray-100 last:border-b-0">
                                <div className="px-4 py-2 bg-gray-50 text-sm font-medium text-gray-700">
                                    {getTypeLabel(type)} ({items.length})
                                </div>
                                {items.slice(0, 3).map((item: any, index: number) => (
                                    <div
                                        key={`${type}-${item.id}-${index}`}
                                        className="px-4 py-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0"
                                        onClick={() => handleResultClick(type, item)}
                                    >
                                        <div className="flex justify-between items-start">
                                            <div>
                                                <p className="font-medium text-gray-900">{item.name}</p>
                                                {type === 'users' || type === 'customers' ? (
                                                    <>
                                                        <p className="text-sm text-gray-500">{item.email}</p>
                                                        {item.phone && (
                                                            <p className="text-sm text-gray-500">{item.phone}</p>
                                                        )}
                                                    </>
                                                ) : type === 'orders' ? (
                                                    <>
                                                        <p className="text-sm text-gray-500">الطالب: {item.customer}</p>
                                                        <p className="text-sm text-gray-500">الدوره: {item.service}</p>
                                                        <p className="text-sm text-gray-500">المصدر: {item.from}</p>
                                                        <p className="text-sm text-gray-500">الحالة: {item.status}</p>
                                                    </>
                                                ) : type === 'branches' ? (
                                                    <>
                                                        <p className="text-sm text-gray-500">
                                                            {item.area}, {item.city}
                                                        </p>
                                                        <p className="text-sm text-gray-500">{item.phone}</p>
                                                        <p className="text-sm text-gray-500">{item.email}</p>
                                                    </>
                                                ) : (
                                                    <p className="text-sm text-gray-500">{item.description}</p>
                                                )}
                                            </div>
                                            <span className="text-xs text-gray-400 bg-gray-100 px-2 py-1 rounded">
                                                {getTypeLabel(type)}
                                            </span>
                                        </div>
                                    </div>
                                ))}
                                {items.length > 3 && (
                                    <div className="px-4 py-2 text-sm text-gray-500 text-center">
                                        و {items.length - 3} نتيجة أخرى...
                                    </div>
                                )}
                            </div>
                        );
                    })}

                    {Object.values(searchResults).every(
                        (items: any) => !Array.isArray(items) || items.length === 0,
                    ) && <div className="px-4 py-8 text-center text-gray-500">
                            لا توجد نتائج للبحث
                        </div>}
                </div>
            )}
        </div>
    );
};

export default SearchResultsDropdown;
